import React, { useEffect, useState } from 'react';
import { EducationalPage } from '@/components/public/EducationalPage';
import { useLivePageContent } from '@/hooks/usePageContent';
import { coursesService } from '@/services/courses.service';
import { mediaUrl } from '@/lib/api';

const SLUG = 'corsi-online';

// Testi di DEFAULT (fallback CMS): l'admin può sovrascrivere eyebrow/title/lead/hero dal CRM Pagine.
const DEFAULTS = {
  eyebrow: 'Educational',
  title: 'Corsi Online',
  lead: 'Formazione e crescita personale ovunque tu sia: segui i percorsi Sila Experiences comodamente online.',
  hero: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1920&q=80',
};

const euro = (n) => `€ ${Number(n || 0).toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

function toCard(c) {
  return {
    id: c.id,
    title: c.title,
    text: c.short || '',
    image: c.cover ? mediaUrl(c.cover) : DEFAULTS.hero,
    price: Number(c.price) > 0 ? euro(c.price) : 'Gratis',
    to: `/educational/corso/${c.slug}`,
  };
}

export default function CorsiOnline() {
  const cms = useLivePageContent(SLUG);
  const [courses, setCourses] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    coursesService.publicList({ mode: 'online' })
      .then((d) => { if (alive) { setCourses((d.courses || []).map(toCard)); setLoaded(true); } })
      .catch(() => { if (alive) { setCourses([]); setLoaded(true); } });
    return () => { alive = false; };
  }, []);

  return (
    <EducationalPage
      eyebrow={cms?.eyebrow || DEFAULTS.eyebrow}
      title={cms?.title || DEFAULTS.title}
      lead={cms?.lead || DEFAULTS.lead}
      hero={cms?.heroImage || DEFAULTS.hero}
      courses={loaded ? courses : []}
      emptyLabel="Nessun corso online disponibile al momento"
      path="/educational/corsi-online"
    />
  );
}
